import React, { useState, useEffect } from "react";
import { Collapse, Button } from "antd";
import CreateKitProductItem from "./CreateKitProductItem";
import { PlusOutlined } from "@ant-design/icons";

const { Panel } = Collapse;

const CreateKitProductList = ({ store_id, setInnerProducts, form }) => {
  const [products, setProducts] = useState([]);
  // { id: 1, name: "Lorem Product", editable: true, quantity: 1, weight: "123" },
  //   { id: 2, name: "Product Ipsum", editable: true, quantity: 1, weight: "200" },
  
  useEffect(() => {
    if (products) {
      setInnerProducts(products)      
    }
  }, []);
  const addProduct = () => {
    setProducts([
      ...products,
      { id: Date.now(), name: "New Product", editable: true, quantity: 1, weight: "" },
    ]);
  };

  const removeProduct = (id) => {
    setProducts(products.filter((product) => product.id !== id));
  };

  const updateProduct = (id, updatedFields) => {
    setProducts(products.map((product) =>
      product.id === id ? { ...product, ...updatedFields } : product
    ));
  };

  return (
    <Collapse defaultActiveKey={["products"]} className="ProductDetailsCollapse">
      <Panel header={`Products (${products.length})`} key="products">
        {products.map((product, index) => {
          const modifiedProduct = index === 0
            ? { ...product, is_primary: true } // add extra variable
            : product;
          return (
            <div key={product.id}>
              <CreateKitProductItem
                kitProduct={products}
                product={modifiedProduct}
                store_id={store_id}
                onUpdate={updateProduct}
                setProduct={setInnerProducts}
                form={form}
                index = {index}
              />
            </div>
          );
        })}
        <Button className="addBtn" onClick={addProduct} icon={<PlusOutlined />}>
          Add Product
        </Button>
      </Panel>
    </Collapse>
  );
};

export default CreateKitProductList;
